import { useFormState } from 'react-final-form';
import { AutocompleteInput } from "ra-ui-materialui";
import { getActivityType, getActivityTypeValue } from "../services/master-tables.service";
import { required } from "ra-core";
import { useState, useEffect } from 'react';

const Types = {
    ServicePackage: "servicePackage",
    Activity: "activity",
    PlannedActivity: "plannedActivity",
    
};


export const ActivityTypeValueInput = props => {
    const { source, isDisabled, type, setTypeValueForm } = props;

    const { values } = useFormState();
    const [activityTypeValue, setactivityTypeValue] = useState();
    const [primaryTypeId, setPrimaryTypeId] = useState();

    const updatePrimaryTypeId = (newTypeId) => {
        if (newTypeId !== primaryTypeId) {
            setPrimaryTypeId(newTypeId);
        }
    };

    useEffect(() => {

        if(primaryTypeId) {
            getActivityType().then(
                res => {
                    var filtered = res?.elements?.filter(e => e?.id === primaryTypeId);
                    getActivityTypeValue(filtered && filtered?.length > 0? filtered[0]?.code: null).then(
                        res => {
                            console.log(res)
                            setactivityTypeValue(res?.elements);
                            if(Types.Activity === type) values.activity.secondaryTypeId = null;
                        }
                    )
                }
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [primaryTypeId])

    
    useEffect(() => {
        switch (type) {
            case Types.ServicePackage:
                if (values?.activityTypeId) updatePrimaryTypeId(values?.activityTypeId);
                break;
            case Types.Activity:
                if (values?.activity?.primaryTypeId) updatePrimaryTypeId(values?.activity?.primaryTypeId);
                break;
            case Types.PlannedActivity:
                if (values?.primaryTypeId) updatePrimaryTypeId(values?.primaryTypeId);
                break;
            default:
                return '';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values, type]); 

    if (!primaryTypeId) return null;


    const handleSelect = (event) => {
        if (type === Types.PlannedActivity && setTypeValueForm) {
            setTypeValueForm(event);
        }
    };

    return (
        <AutocompleteInput
            label="Subtipología dinámica"
            source={source}
            choices={activityTypeValue}
            disabled={isDisabled}
            optionText="value"
            optionValue="id"
            validate={[required()]}
            options={{ InputProps: { autoComplete: 'off' }, autoComplete: 'off' }}
            resettable={true}
            onSelect={handleSelect}  
        />
    );
};